import {
    FETCH_NEWSLETTER,
    FETCH_NEWSLETTER_SUCCESS, FETCH_NEWSLETTER_FAILS,
} from './NewsLetterActionType';

export const newsLetterReducer = (
    state = {
        fetching: false,
        error: { status: false, message: '' },
        data: []
    },
    action
) => {
    switch (action.type) {
        case FETCH_NEWSLETTER:
            return {
                ...state,
                fetching: true,
                error: { status: false, message: '' }
            };

        case FETCH_NEWSLETTER_SUCCESS:
            return {
                ...state,
                fetching: false,
                error: { status: false, message: '' },
                data: action.payload
            };

        case FETCH_NEWSLETTER_FAILS:
            return {
                ...state,
                ...state.newsLetter,
                fetching: false,
                error: { status: true, message: action.payload }
            };
        default:
            return state;
    }
};
